import { render, staticRenderFns } from "./orderAfter.vue?vue&type=template&id=09ab1498&scoped=true&"
import script from "./orderAfter.vue?vue&type=script&lang=js&"
export * from "./orderAfter.vue?vue&type=script&lang=js&"
import style0 from "./orderAfter.vue?vue&type=style&index=0&id=09ab1498&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ab1498",
  null
  
)

component.options.__file = "orderAfter.vue"
export default component.exports